import { createOrderCreationSlice } from 'common/stores/redux/OrderCreation';

const clientOrderCreationSlice = createOrderCreationSlice(
    'clientOrderCreation'
);

export const {
    initialize,
    setOrder,
    updateOrder,
    resetPages,
    initializeRoute,
    updateKeyValuePair,
    addNote,
    initFinancialInformation,
    updatePayment,
    updateBilling,
    updateNote,
    updateSpecialInstructions,
    addContact,
    removeContact,
    addComment,
    updateComment,
    addFolderAttachment,
    removeFolderAttachment,
    updateFulfillmentLogistics,
    setFinanceEdit,
    updateFulfillmentDetails,
    updateTradeType,
    updateProperty,
    reset,
} = clientOrderCreationSlice.actions;

export default clientOrderCreationSlice.reducer;
